import React from 'react';
import { FreeProductsReducer } from '../../../interfaces';

import { getVariable, renderCdnUrl } from '../../../helpers/helpers';
import * as _ from 'lodash';
import { Loader, ErrorDisplay, Wrap } from '../../../components';
import { Row } from 'react-styled-flexboxgrid';
import { useTranslation } from 'react-i18next';
import BonusBanner from '../../../components/BonusBanner';
export interface ThankyouProps {
  page: FreeProductsReducer;
  app: any;
}
const Thankyou: React.FC<ThankyouProps> = (props) => {
  const swsmInternal = getVariable('mode', 'swsm', false);
  const { loading, error } = props.page.basicInfo.status;
  const orderNumber = _.get(props, 'page.order.data');

  const [isOderNumber, setOrderNumber] = React.useState();
  const lastOrder = _.last(props.page.basicInfo.data?.swsm_orders);
  const orderNumber2 = _.get(lastOrder, 'order_id');
  const [t] = useTranslation('common');
  const thanks = t('portal.free_products.thank_you.title');
  const getOrder = t('portal.free_products.thank_you.got_order');
  const receiveEmail = t('portal.free_products.thank_you.receive_email');

  const mergeText = `${getOrder}. ${receiveEmail}`;
  console.log(props.page);
  React.useEffect(() => {
    setOrderNumber(orderNumber);
  }, [orderNumber, swsmInternal]);

  if (loading) {
    return (
      <div style={{ position: 'relative', height: '100px' }}>
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ position: 'relative', height: '100px' }}>
        <ErrorDisplay />
      </div>
    );
  }

  return (
    <Wrap>
      <Row>
        {' '}
        <BonusBanner
          bgPosition="center"
          imageUrl={renderCdnUrl('images/banners/packaging.jpg')}
          title={thanks}
          desc={mergeText}
          hasOverlay
          subText={`Order number: ${isOderNumber === null ? orderNumber2 : isOderNumber}`}
        />
      </Row>
    </Wrap>
  );
};

export default Thankyou;
